import React from 'react'
import { FieldComponent } from 'components/Shared/FieldComponent'
import CustomFieldType from 'constants/CustomFieldTypes'
import LabeledCheckboxField from 'components/Shared/LabeledCheckboxField/LabeledCheckboxField'
import { DatePickerFormFieldInline } from 'components/Shared/DatePickerInline'
import { DateTimePickerField } from 'components/Shared/DateTimePickerField'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import styles from './CustomFieldFormField.module.css'
import { useFieldFast } from 'hooks/useFieldFast'
import { CustomField } from 'components/CustomFields/CustomFieldsColumn/CustomField'

export function CustomFieldFormField ({ definition, entityId, disabled }) {
  const { id: definitionId, type, translations, selectOptions, isRequired } = definition

  const fieldName = `customFields.${definitionId}`
  const [{ value }, , { setValue }] = useFieldFast(fieldName)

  return <CustomField
    definition={definition}
    entityId={entityId}
    value={value}
    onValueChanged={setValue}
    renderField={getTranslation => {
      const label = getTranslation(translations)
      switch (type) {
        case CustomFieldType.Boolean:
          return <div className={styles.checkboxContainer}>
            <LabeledCheckboxField
              fieldName={fieldName}
              label={label}
              disabled={disabled}
            />
          </div>
        case CustomFieldType.Date:
          return <DatePickerFormFieldInline
            name={fieldName}
            label={label}
            disabled={disabled}
            clearable/>
        case CustomFieldType.DateTime:
          return <div className={styles.dateTimeContainer}>
            <DateTimePickerField
              label={label}
              placeholder={label}
              fieldName={fieldName}
              disabled={disabled}
              disableClear={false}/>
          </div>
        case CustomFieldType.Text:
          return <FieldComponent
            fieldName={fieldName}
            disabled={disabled}
            label={label}/>
        case CustomFieldType.Select:
          return <ControlledSelectField
            options={selectOptions}
            label={label}
            fieldName={fieldName}
            disableClear={isRequired}
            disabled={disabled}
            getOptionValue={option => option.id}
            getOptionLabel={option => getTranslation(option.translations)}/>
        default:
          return <></>
      }
    }}/>
}
